import type { ExtractPropTypes, PropType } from 'vue'
import type _Link from './link.vue'

import { linkProps } from 'element-plus'

export const sdLinkProps = {
    type     : linkProps.type,
    underline: { type: String as PropType<'none' | 'hover' | 'always'>, default: 'hover' },
    disabled : linkProps.disabled,
    href     : linkProps.href,
    icon     : linkProps.icon,

    // 扩展属性
    replace : { type: Boolean , default: false }, // 替换当前路由页面 
    text    : { type: String  , default: ''    }, // 显示文字
    size    : { type: String                   }, // 文字大小
    color   : { type: String                   }, // 文字颜色
} 

export type SdLinkProps    = ExtractPropTypes<typeof sdLinkProps>
export type SdLinkInstance = InstanceType<typeof _Link>


